import {connect} from 'react-redux';
import UserManagementScreen from '../../components/screens/UserManagementScreen';

const UserManagementScreenContainer = connect(
    null,
    null
)(UserManagementScreen);

export default UserManagementScreenContainer;